import {
  addNavMenuItem,
  registerBulkAction,
  registerFormInputComponent,
  registerPageTab,
  PageLocationId,
} from "@bb-vendure/admin-ui/core";
import { deleteNoticeBulkAction } from "./components/bulkAction";
import { NoticeTableComponent } from "./components/table/notice-table.component";

export default [
  addNavMenuItem(
    {
      id: "notice-board",
      label: "nav.notice",
      routerLink: ["/extensions/notice"],
      icon: "pinboard",
    },
    "marketing"
  ),

  registerPageTab({
    location: "notice-list" as PageLocationId,
    tab: "nav.notice",
    route: "/extensions/notice",
    //tabIcon: "star",
    component: NoticeTableComponent,
  }),

  registerPageTab({
    location: "notice-list" as PageLocationId,
    tab: "nav.notice-winner-announcement",
    route: "/extensions/notice/winner-announcement",
    //tabIcon: "star",
    component: NoticeTableComponent,
  }),

  registerBulkAction(deleteNoticeBulkAction),
];
